/**
 * SingleClipPage - public shareable page for a single clip (/clip/:clipId)
 */
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, Loader2, Play } from 'lucide-react';
import { ClipCard } from '../components/Clips';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const SingleClipPage = () => {
  const { clipId } = useParams();
  const navigate = useNavigate();
  const [clip, setClip] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchClip = async () => {
      try {
        const res = await fetch(`${API_URL}/api/radio/clips/${clipId}`);
        if (res.ok) {
          const data = await res.json();
          setClip(data.clip);
        }
      } catch (err) {
        console.error('Fetch clip error:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchClip();
  }, [clipId]);

  return (
    <div className="h-screen w-full bg-black relative" data-testid="single-clip-page">
      <button
        onClick={() => navigate('/clips')}
        className="absolute top-4 left-4 z-30 p-2 bg-black/50 hover:bg-black/70 rounded-full transition"
        data-testid="single-clip-back-btn"
      >
        <ArrowLeft className="w-6 h-6 text-white" />
      </button>

      {loading ? (
        <div className="h-full flex items-center justify-center">
          <Loader2 className="w-8 h-8 text-purple-500 animate-spin" />
        </div>
      ) : clip ? (
        <ClipCard clip={clip} isActive={true} hideBrand={true} />
      ) : (
        <div className="h-full flex flex-col items-center justify-center text-white p-6 text-center">
          <Play className="w-14 h-14 text-gray-600 mb-4" />
          <h2 className="text-xl font-bold mb-2">Clip not found</h2>
          <button
            onClick={() => navigate('/clips')}
            className="mt-4 px-5 py-2.5 rounded-full bg-gradient-to-r from-[#00F0FF] to-[#FF007F] text-white font-semibold"
          >
            Browse Clips
          </button>
        </div>
      )}
    </div>
  );
};

export default SingleClipPage;
